import api from "../api"
import CommonConst from "./const"

export default class Common {
    static authorization_check(){
        // セッションタイムアウトチェック
        var nowdate = new Date();
        var timeout = JSON.parse(sessionStorage.getItem("u2m_operator")).timeout
        if (nowdate >= timeout){
            return false;
        }
        // リロード用Authorization再設定
        if (!api.defaults.headers.common["Authorization"]) {
            api.defaults.headers.common["Authorization"] = JSON.parse(sessionStorage.getItem("u2m_operator")).accessToken
        }
        return true;
    }

    // 一覧種別の値に対応する文字列を返却
    static listTypeList() {
        var listTypeList = [
            {text: "問い合わせ一覧", listType: CommonConst.LISTTYPE_ENQUIRY},
            {text: "決済一覧", listType: CommonConst.LISTTYPE_SETTLEMENT}
        ]
        return listTypeList
    }

    // 一覧種別の値に対応する文字列を返却
    static setListTypeName(listType) {
        var listTypeName = ""
        if (listType === CommonConst.LISTTYPE_ENQUIRY) {
            listTypeName = "申告"
        } else if (listType === CommonConst.LISTTYPE_SETTLEMENT) {
            listTypeName = "決済"
        }
        return listTypeName
    }

    // サービス種別に対応する文字列を返却
    static serviceTypeList() {
        var serviceTypeList = [
            {text: "全て",service_type: CommonConst.SERVICE_TYPE_ALL},
            {text: "d払い等決済サービス",service_type: CommonConst.SERVICE_TYPE_DCMPAY},
            {text: "d払い残高(チャージ/出金/送金)",service_type: CommonConst.SERVICE_TYPE_WALLET},
            {text: "オンラインショップ",service_type: CommonConst.SERVICE_TYPE_ONLINESHOP},
            {text: "ahamo",service_type: CommonConst.SERVICE_TYPE_AHAMO}
        ]
        return serviceTypeList
    }

    // ステータスに対応する文字列を返却
    static statusList(value) {
        var statusList = [
            {text: "指定なし", status: ''},
            {text: "新規受付", status: CommonConst.STATUS_NEWENTRY},
            {text: "主管部調査中", status: CommonConst.STATUS_WS_PROGRESS},
            {text: "SD部依頼中", status: CommonConst.STATUS_SD_REQUEST},
            {text: "SD部調査中", status: CommonConst.STATUS_SD_PROGRESS},
            {text: "SD部調査完了", status: CommonConst.STATUS_SD_COMPLETE},
            {text: "補償判断中", status: CommonConst.STATUS_REPAIR_JUDGE},
            {text: "未調査", status:CommonConst.STATUS_NO_INVESTIGATION},
            {text: "要データ抽出", status:CommonConst.STATUS_REQUIRE_DATA_EXTRACTION},
            {text: "補償OK", status: CommonConst.STATUS_REPAIR_OK},
            {text: "補償NG", status: CommonConst.STATUS_REPAIR_NG},
        ]
        if (value == CommonConst.LISTTYPE_ENQUIRY) {
            statusList.push({text:"補償OK（一部NGあり）", status:CommonConst.STATUS_REPAIR_MIX})
            statusList.push({text:"調査完了（文書発送）", status:CommonConst.STATUS_COMPLETE_DOC})
            statusList.push({text:"調査完了（架電）", status:CommonConst.STATUS_COMPLETE_TEL})
        }
        return statusList
    }

    // サブステータスに対応する文字列を返却
    static substatusList() {
        var substatusList = [
            {text: "未定", substatus: CommonConst.SUBSTATUS_NONE},
            {text: "フィッシング", substatus: CommonConst.SUBSTATUS_PHISHING},
            {text: "リスト攻撃", substatus: CommonConst.SUBSTATUS_LIST_ATTACK},
            {text: "マルウェア", substatus:CommonConst.SUBSTATUS_MALWARE},
            {text: "捨てアカ決済", substatus:CommonConst.SUBSTATUS_DISCARDED_ACCOUNTS},
            {text: "メールアカウント乗っ取り", substatus:CommonConst.SUBSTATUS_HIJACKING_MAILACCOUNTS},
            {text: "調査取下げ", substatus:CommonConst.SUBSTATUS_CANCEL_INVEST},
            {text: "判定不可", substatus:CommonConst.SUBSTATUS_CANNOT_JUDGE},
            {text: "調査不可", substatus:CommonConst.SUBSTATUS_CANNOT_INVEST},
            {text: "第三者アクセス（不正グループ案件）", substatus:CommonConst.SUBSTATUS_THIRD_PARTY_ACCESS_FOREIGNERS},
            {text: "第三者アクセス", substatus:CommonConst.SUBSTATUS_THIRD_PARTY_ACCESS},
            {text: "本人利用", substatus: CommonConst.SUBSTATUS_PERSONALUSE},
        ]
        return substatusList
    }

    // 権限に対応する文字列を返却
    static authority(value) {
        var authority = ""
        if(value == CommonConst.USER_AUTHORITY_ADMIN){
            authority = "管理者";
        }else if(value == CommonConst.USER_AUTHORITY_AGENCY){
            authority = "代行者";
        }else{
            authority = "運営者";
        }
        return authority
    }

    // 支払方法_dcmpayに対応する文字列を表示
    static settlement_meansList_dcmpay() {
        var settlement_meansList = [
            {text: "指定なし", settlement_means: ''},
            {text: "合算", settlement_means: CommonConst.SETTLEMENT_MEANS_TOTALING},
            {text: "ｄ払い残高", settlement_means: CommonConst.SETTLEMENT_MEANS_DCMWALLET},
            {text: "クレジット払い", settlement_means: CommonConst.SETTLEMENT_MEANS_CREDIT},
            {text: "dカード払い", settlement_means: CommonConst.SETTLEMENT_MEANS_DCARD},
            {text: "コンビニ払い", settlement_means: CommonConst.SETTLEMENT_MEANS_CONVENIENCE},
            {text: "代引き", settlement_means: CommonConst.SETTLEMENT_MEANS_CASHON}
        ]
        return settlement_meansList
    }

    // 課金種別に対応する文字列を返却
    static billing_methodList() {
        var billing_methodList = [
            {text:"指定なし", billing_method: ''},
            {text:"都度決済", billing_method: CommonConst.BILLING_METHOD_EACHTIME},
            {text:"継続課金", billing_method: CommonConst.BILLING_METHOD_PERIODICALLY},
            {text:"随時決済", billing_method: CommonConst.BILLING_METHOD_ANYTIME},
        ]
        return billing_methodList
    }

    // 取引区分に対応する文字列を返却
    static trading_classList() {
        var trading_classList = [
            {text:"指定なし", trading_class:''},
            {text:"ペイジー入金", trading_class:CommonConst.WALLET_TRADING_CLASS_001},
            {text:"口座間送金入金", trading_class: CommonConst.WALLET_TRADING_CLASS_002},
            {text:"口座間送金キャンセル入金", trading_class: CommonConst.WALLET_TRADING_CLASS_003},
            {text:"口座間送金拒否入金", trading_class: CommonConst.WALLET_TRADING_CLASS_004},
            {text:"送金組戻入金", trading_class: CommonConst.WALLET_TRADING_CLASS_005},
            {text:"振込不能入金", trading_class: CommonConst.WALLET_TRADING_CLASS_006},
            {text:"海外送金組戻入金", trading_class: CommonConst.WALLET_TRADING_CLASS_007},
            {text:"ペイジー入金二重収納", trading_class: CommonConst.WALLET_TRADING_CLASS_008},
            {text:"入金取消後ペイジー入金", trading_class: CommonConst.WALLET_TRADING_CLASS_009},
            {text:"コンビニ入金", trading_class: CommonConst.WALLET_TRADING_CLASS_010},
            {text:"ケータイ払い決済取消入金", trading_class: CommonConst.WALLET_TRADING_CLASS_011},
            {text:"ケータイ払い決済期限切れ入金", trading_class: CommonConst.WALLET_TRADING_CLASS_012},
            {text:"ケータイ払い決済返金入金", trading_class: CommonConst.WALLET_TRADING_CLASS_013},
            {text:"返金先口座入金", trading_class: CommonConst.WALLET_TRADING_CLASS_014},
            {text:"ｄジョブ報酬額＿入金（無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_015},
            {text:"ｄジョブ報酬額＿入金（有料）", trading_class: CommonConst.WALLET_TRADING_CLASS_016},
            {text:"プリペイド決済オーソリ返品入金", trading_class: CommonConst.WALLET_TRADING_CLASS_017},
            {text:"プリペイド決済障害返品入金", trading_class: CommonConst.WALLET_TRADING_CLASS_018},
            {text:"プリペイド決済減額入金", trading_class: CommonConst.WALLET_TRADING_CLASS_019},
            {text:"プリペイド決済返品入金", trading_class: CommonConst.WALLET_TRADING_CLASS_020},
            {text:"プリペイド決済補正入金（利用金額返金）", trading_class: CommonConst.WALLET_TRADING_CLASS_021},
            {text:"プリペイド決済補正入金（発行手数料返金）", trading_class: CommonConst.WALLET_TRADING_CLASS_022},
            {text:"プリペイド決済補正入金（通信障害返金）", trading_class: CommonConst.WALLET_TRADING_CLASS_023},
            {text:"プリペイド決済補正入金（その他）", trading_class: CommonConst.WALLET_TRADING_CLASS_024},
            {text:"プリペイド自動入金", trading_class: CommonConst.WALLET_TRADING_CLASS_025},
            {text:"モバチェ充当出金", trading_class: CommonConst.WALLET_TRADING_CLASS_026},
            {text:"銀行口座振込出金", trading_class: CommonConst.WALLET_TRADING_CLASS_027},
            {text:"口座間送金出金", trading_class: CommonConst.WALLET_TRADING_CLASS_028},
            {text:"送金組戻出金", trading_class: CommonConst.WALLET_TRADING_CLASS_029},
            {text:"コンビニ入金取消出金", trading_class: CommonConst.WALLET_TRADING_CLASS_030},
            {text:"ケータイ払い出金", trading_class: CommonConst.WALLET_TRADING_CLASS_031},
            {text:"ケータイ払い決済増額出金", trading_class: CommonConst.WALLET_TRADING_CLASS_032},
            {text:"返金元口座出金", trading_class: CommonConst.WALLET_TRADING_CLASS_033},
            {text:"銀行口座振込出金（振込無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_034},
            {text:"もどきGrp異動解約＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_035},
            {text:"海外送金出金", trading_class: CommonConst.WALLET_TRADING_CLASS_036},
            {text:"プリペイド決済カード発行出金", trading_class: CommonConst.WALLET_TRADING_CLASS_037},
            {text:"プリペイド決済オーソリ出金", trading_class: CommonConst.WALLET_TRADING_CLASS_038},
            {text:"プリペイド決済増額出金", trading_class: CommonConst.WALLET_TRADING_CLASS_039},
            {text:"プリペイド決済障害取消出金", trading_class: CommonConst.WALLET_TRADING_CLASS_040},
            {text:"プリペイド決済補正出金（残高不足）", trading_class: CommonConst.WALLET_TRADING_CLASS_041},
            {text:"プリペイド決済補正出金（その他）", trading_class: CommonConst.WALLET_TRADING_CLASS_042},
            {text:"返金出金（回線無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_043},
            {text:"返金出金（回線有料）", trading_class: CommonConst.WALLET_TRADING_CLASS_044},
            {text:"返金出金（CF無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_045},
            {text:"返金出金（CF有料）", trading_class: CommonConst.WALLET_TRADING_CLASS_046},
            {text:"不能金額入金（回線）", trading_class: CommonConst.WALLET_TRADING_CLASS_047},
            {text:"不能金額入金（CF）", trading_class: CommonConst.WALLET_TRADING_CLASS_048},
            {text:"不能手数料入金（回線）", trading_class: CommonConst.WALLET_TRADING_CLASS_049},
            {text:"不能手数料入金（CF）", trading_class: CommonConst.WALLET_TRADING_CLASS_050},
            {text:"報酬額＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_051},
            {text:"報酬額＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_052},
            {text:"システム利用料＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_053},
            {text:"システム利用料＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_054},
            {text:"ポイント報酬額＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_055},
            {text:"ポイント報酬額＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_056},
            {text:"クライアント口座＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_057},
            {text:"クライアント口座＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_058},
            {text:"払い出し＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_059},
            {text:"払い出し＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_060},
            {text:"払い出し不能＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_061},
            {text:"払い出し不能＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_062},
            {text:"銀行連携＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_063},
            {text:"銀行連携＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_064},
            {text:"支払用口座＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_065},
            {text:"支払用口座＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_066},
            {text:"クライアント返金＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_067},
            {text:"クライアント返金＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_068},
            {text:"クライアント繰越＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_069},
            {text:"クライアント繰越＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_070},
            {text:"入金用口座＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_071},
            {text:"入金用口座＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_072},
            {text:"クライアント拒否＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_073},
            {text:"クライアント拒否＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_074},
            {text:"報酬予定額＿入金", trading_class: CommonConst.WALLET_TRADING_CLASS_075},
            {text:"報酬予定額＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_076},
            {text:"収入化＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_077},
            {text:"報酬額＿入金（補正）", trading_class: CommonConst.WALLET_TRADING_CLASS_078},
            {text:"報酬額＿出金（補正）", trading_class: CommonConst.WALLET_TRADING_CLASS_079},
            {text:"ポイント化＿出金", trading_class: CommonConst.WALLET_TRADING_CLASS_080},
            {text:"報酬額＿出金（雑収）", trading_class: CommonConst.WALLET_TRADING_CLASS_081},
            {text:"解約返金＿入金（補正）", trading_class: CommonConst.WALLET_TRADING_CLASS_082},
            {text:"ｄカーＳ使用料入金（無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_083},
            {text:"ｄカーＳ使用料入金（有料）", trading_class: CommonConst.WALLET_TRADING_CLASS_084},
            {text:"障害取消入金", trading_class: CommonConst.WALLET_TRADING_CLASS_085},
            {text:"口座間送金出金_D", trading_class: CommonConst.WALLET_TRADING_CLASS_086},
            {text:"口座間送金入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_087},
            {text:"ペイジー入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_088},
            {text:"ペイジー入金二重収納_W", trading_class: CommonConst.WALLET_TRADING_CLASS_089},
            {text:"入金取消後ペイジー入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_090},
            {text:"コンビニ入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_091},
            {text:"ケータイ払い出金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_092},
            {text:"決済取消入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_093},
            {text:"決済期限切れ入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_094},
            {text:"決済返金入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_095},
            {text:"決済増額出金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_096},
            {text:"銀行連携＿出金_D", trading_class: CommonConst.WALLET_TRADING_CLASS_097},
            {text:"銀行連携＿入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_098},
            {text:"ATM預入＿出金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_099},
            {text:"ATM預入＿入金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_100},
            {text:"異動解約出金（雑収）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_101},
            {text:"昇格ウォレット出金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_102},
            {text:"昇格ｄ払い残高入金_D", trading_class: CommonConst.WALLET_TRADING_CLASS_103},
            {text:"失効出金（雑収）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_104},
            {text:"口座引落し＿入金_D", trading_class: CommonConst.WALLET_TRADING_CLASS_105},
            {text:"口座引落し＿入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_106},
            {text:"CF異動解約＿出金_D", trading_class: CommonConst.WALLET_TRADING_CLASS_107},
            {text:"送金組戻入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_108},
            {text:"送金組戻出金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_109},
            {text:"口座間送金出金（無料）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_110},
            {text:"口座間送金入金（無料）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_111},
            {text:"障害取消入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_112},
            {text:"手数料課金なし", trading_class: CommonConst.WALLET_TRADING_CLASS_113},
            {text:"送り手負担送金利用料", trading_class: CommonConst.WALLET_TRADING_CLASS_114},
            {text:"受け手負担送金利用料", trading_class: CommonConst.WALLET_TRADING_CLASS_115},
            {text:"海外送金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_116},
            {text:"銀行振込出金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_117},
            {text:"振込不能手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_118},
            {text:"組戻出金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_119},
            {text:"組戻入金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_120},
            {text:"海外組戻手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_121},
            {text:"dジョブ入金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_122},
            {text:"dジョブ出金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_123},
            {text:"銀行ATM預入＿出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_124},
            {text:"銀行ATM預入＿入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_125},
            {text:"銀行ATM払出＿出金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_126},
            {text:"銀行ATM払出＿入金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_127},
            {text:"銀行ATM払出取消＿出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_128},
            {text:"銀行ATM払出取消＿入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_129},
            {text:"銀行ATM払出手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_130},
            {text:"送り手負担送金利用料_D", trading_class: CommonConst.WALLET_TRADING_CLASS_131},
            {text:"受け手負担送金利用料_W", trading_class: CommonConst.WALLET_TRADING_CLASS_132},
            {text:"組戻入金手数料_W", trading_class: CommonConst.WALLET_TRADING_CLASS_133},
            {text:"組戻出金手数料_W", trading_class: CommonConst.WALLET_TRADING_CLASS_134},
            {text:"投資預入＿出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_135},
            {text:"投資預入＿入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_136},
            {text:"投資払出＿出金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_137},
            {text:"投資払出＿入金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_138},
            {text:"融資預入＿出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_139},
            {text:"融資預入＿入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_140},
            {text:"融資払出＿出金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_141},
            {text:"融資払出＿入金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_142},
            {text:"投資預入＿出金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_143},
            {text:"投資預入＿入金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_144},
            {text:"融資預入＿出金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_145},
            {text:"融資預入＿入金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_146},
            {text:"口座間送金出金（URL）", trading_class: CommonConst.WALLET_TRADING_CLASS_147},
            {text:"口座間送金入金（URL）", trading_class: CommonConst.WALLET_TRADING_CLASS_148},
            {text:"口座間送金出金_D（URL）", trading_class: CommonConst.WALLET_TRADING_CLASS_149},
            {text:"口座間送金入金_W（URL）", trading_class: CommonConst.WALLET_TRADING_CLASS_150},
            {text:"口座間送キャン入金（URL）", trading_class: CommonConst.WALLET_TRADING_CLASS_151},
            {text:"口座間送金拒否入金（URL）", trading_class: CommonConst.WALLET_TRADING_CLASS_152},
            {text:"口座引落し＿入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_153},
            {text:"銀行ATM預入＿入金（個人）_C", trading_class: CommonConst.WALLET_TRADING_CLASS_154},
            {text:"コンビニ入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_155},
            {text:"ケータイ払い出金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_156},
            {text:"決済取消入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_157},
            {text:"決済期限切れ入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_158},
            {text:"決済返金入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_159},
            {text:"決済増額出金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_160},
            {text:"障害取消入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_161},
            {text:"補正入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_162},
            {text:"補正出金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_163},
            {text:"補正入金手数料_C", trading_class: CommonConst.WALLET_TRADING_CLASS_164},
            {text:"補正出金手数料_C", trading_class: CommonConst.WALLET_TRADING_CLASS_165},
            {text:"異動解約＿出金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_166},
            {text:"銀行口座限度額超え出金", trading_class: CommonConst.WALLET_TRADING_CLASS_167},
            {text:"銀行ATM限度額超え出金", trading_class: CommonConst.WALLET_TRADING_CLASS_168},
            {text:"銀行ATM限度額超え入金", trading_class: CommonConst.WALLET_TRADING_CLASS_169},
            {text:"コンビニ入金手数料_C", trading_class: CommonConst.WALLET_TRADING_CLASS_170},
            {text:"ペイジー入金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_171},
            {text:"コンビニ入金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_172},
            {text:"ペイジー入金手数料_W", trading_class: CommonConst.WALLET_TRADING_CLASS_173},
            {text:"コンビニ入金手数料_W", trading_class: CommonConst.WALLET_TRADING_CLASS_174},
            {text:"海外送金＿出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_175},
            {text:"海外送金＿出金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_176},
            {text:"海外送金＿出金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_177},
            {text:"海外送金＿入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_178},
            {text:"海外送金＿入金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_179},
            {text:"海外送金＿入金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_180},
            {text:"ｄ払い残高チャージ_D", trading_class: CommonConst.WALLET_TRADING_CLASS_181},
            {text:"外部チャージ仮登録出金", trading_class: CommonConst.WALLET_TRADING_CLASS_182},
            {text:"外部チャージ本登録出金", trading_class: CommonConst.WALLET_TRADING_CLASS_183},
            {text:"外部チャージ取消入金", trading_class: CommonConst.WALLET_TRADING_CLASS_184},
            {text:"外部チャージ拒否入金", trading_class: CommonConst.WALLET_TRADING_CLASS_185},
            {text:"外部チャージ入金", trading_class: CommonConst.WALLET_TRADING_CLASS_186},
            {text:"加盟店ウォレット入金", trading_class: CommonConst.WALLET_TRADING_CLASS_187},
            {text:"加盟店ウォレット出金", trading_class: CommonConst.WALLET_TRADING_CLASS_188},
            {text:"加盟店ウォレット振込出金", trading_class: CommonConst.WALLET_TRADING_CLASS_189},
            {text:"加盟店ウォレット振込手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_190},
            {text:"新融資預入_出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_191},
            {text:"新融資預入_入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_192},
            {text:"新融資払出_出金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_193},
            {text:"新融資払出_入金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_194},
            {text:"新融資預入_出金（法人）D", trading_class: CommonConst.WALLET_TRADING_CLASS_195},
            {text:"新融資預入_入金（個人）W", trading_class: CommonConst.WALLET_TRADING_CLASS_196},
            {text:"給与振込＿出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_197},
            {text:"給与振込＿出金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_198},
            {text:"経費精算＿出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_199},
            {text:"経費精算＿出金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_200},
            {text:"給与振込＿入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_201},
            {text:"給与振込＿入金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_202},
            {text:"経費精算＿入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_203},
            {text:"経費精算＿入金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_204},
            {text:"SO連携送金出金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_205},
            {text:"SO連携送金出金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_206},
            {text:"SO連携送金出金（個人）_C", trading_class: CommonConst.WALLET_TRADING_CLASS_207},
            {text:"SO連携送金入金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_208},
            {text:"SO連携送金入金（法人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_209},
            {text:"SO連携送金入金（法人）_C", trading_class: CommonConst.WALLET_TRADING_CLASS_210},
            {text:"預り金送金_入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_211},
            {text:"預り金送金_入金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_212},
            {text:"預り金送金_出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_213},
            {text:"預り金送金_出金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_214},
            {text:"銀行口座振込出金（手数料無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_215},
            {text:"銀行口座限度額超え出金（手数料無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_216},
            {text:"銀行ATM払出＿出金（手数料無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_217},
            {text:"銀行ATM限度額超え出金（手数料無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_218},
            {text:"送金原資入金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_219},
            {text:"オートチャージ＿入金_D", trading_class: CommonConst.WALLET_TRADING_CLASS_220},
            {text:"オートチャージ＿入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_221},
            {text:"オートチャージ＿入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_222},
            {text:"別用途＿出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_223},
            {text:"別用途＿出金（法人）_D", trading_class: CommonConst.WALLET_TRADING_CLASS_224},
            {text:"別用途＿入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_225},
            {text:"別用途＿入金（個人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_226},
            {text:"送金原資返金出金", trading_class:CommonConst.WALLET_TRADING_CLASS_227},
            {text:"口座引落しＢＰ＿入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_231},
            {text:"オートチャージＢＰ＿入金_C", trading_class: CommonConst.WALLET_TRADING_CLASS_232},
            {text:"口座引落しＢＰ＿入金_D", trading_class: CommonConst.WALLET_TRADING_CLASS_233},
            {text:"口座引落しＢＰ＿入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_234},
            {text:"オートチャージＢＰ＿入金_D", trading_class: CommonConst.WALLET_TRADING_CLASS_235},
            {text:"オートチャージＢＰ＿入金_W", trading_class: CommonConst.WALLET_TRADING_CLASS_236},
            {text:"不足額月初チャージBS_D", trading_class: CommonConst.WALLET_TRADING_CLASS_237},
            {text:"不足額月初チャージBS_W", trading_class: CommonConst.WALLET_TRADING_CLASS_238},
            {text:"不足額月初チャージBS_C", trading_class: CommonConst.WALLET_TRADING_CLASS_239},
            {text:"不足額加盟店チャージBS_D", trading_class: CommonConst.WALLET_TRADING_CLASS_240},
            {text:"不足額加盟店チャージBS_W", trading_class: CommonConst.WALLET_TRADING_CLASS_241},
            {text:"不足額加盟店チャージBS_C", trading_class: CommonConst.WALLET_TRADING_CLASS_242},
            {text:"不足額月初チャージBP_D", trading_class: CommonConst.WALLET_TRADING_CLASS_243},
            {text:"不足額月初チャージBP_W", trading_class: CommonConst.WALLET_TRADING_CLASS_244},
            {text:"不足額月初チャージBP_C", trading_class: CommonConst.WALLET_TRADING_CLASS_245},
            {text:"不足額加盟店チャージBP_D", trading_class: CommonConst.WALLET_TRADING_CLASS_246},
            {text:"不足額加盟店チャージBP_W", trading_class: CommonConst.WALLET_TRADING_CLASS_247},
            {text:"不足額加盟店チャージBP_C", trading_class: CommonConst.WALLET_TRADING_CLASS_248},
            {text:"請求支払出金", trading_class: CommonConst.WALLET_TRADING_CLASS_249},
            {text:"請求支払入金", trading_class: CommonConst.WALLET_TRADING_CLASS_250},
            {text:"ペイロール振込出金", trading_class: CommonConst.WALLET_TRADING_CLASS_251},
            {text:"ペイロール振込出金（手数料無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_252},
            {text:"ペイロール振込不能入金", trading_class: CommonConst.WALLET_TRADING_CLASS_253},
            {text:"ペイロール振込出金手数料", trading_class: CommonConst.WALLET_TRADING_CLASS_254},
            {text:"ｄ投資預入_出金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_255},
            {text:"ｄ投資預入_入金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_256},
            {text:"ｄ投資払出_出金（個人）", trading_class: CommonConst.WALLET_TRADING_CLASS_257},
            {text:"ｄ投資払出_入金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_258},
            {text:"ｄ投資預入_出金（法人）D", trading_class: CommonConst.WALLET_TRADING_CLASS_259},
            {text:"ｄ投資預入_入金（個人）W", trading_class: CommonConst.WALLET_TRADING_CLASS_260},
            {text:"銀行口座振込出金（全ユーザ無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_261},
            {text:"銀行口座限度額超え出金（全ユーザ無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_262},
            {text:"銀行ATM払出＿出金（全ユーザ無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_263},
            {text:"銀行ATM限度額超え出金（全ユーザ無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_264},
            {text:"ペイロール振込出金（全ユーザ無料）", trading_class: CommonConst.WALLET_TRADING_CLASS_265},
            {text:"回線不備入金（法人）", trading_class: CommonConst.WALLET_TRADING_CLASS_266},
            {text:"回線不備入金（法人）_W", trading_class: CommonConst.WALLET_TRADING_CLASS_267},
            {text:"回線不備入金（法人）_C", trading_class: CommonConst.WALLET_TRADING_CLASS_268},
        ]
        return trading_classList
    }

    // リスト項目の表示変換
    static displayListType(value){
        // 対応する文字列を表示
        var listTable = {
            "01": "問い合わせ一覧",
            "02": "決済一覧",
        }
        if (typeof listTable[value] === "undefined"){
            return "想定外データ"
        }
        return listTable[value]
    }

    // リスト項目の表示変換
    static displayStatus(value){
        // ステータスに対応するステータス文字列を表示
        var statusTable = {
            "000": "新規受付",
            "001": "主管部調査中",
            "002": "SD部依頼中",
            "003": "SD部調査中",
            "004": "SD部調査完了",
            "005": "補償判断中",
            "006": "補償OK",
            "007": "補償NG",
            "008": "補償OK（一部NGあり）",
            "009": "補償可否案内（文書発送）",
            "010": "補償可否案内（架電）",
            "011": "要補正（ポイント補正）",
            "012": "要補正（請求額訂正）",
            "013": "要補正（クレカ取消）",
            "014": "補正完了",
            "015": "調査取下げ",
            "016": "申告書対応",
            "017": "申告書受領",
            "018": "要補正（混合）",
            "019": "対応完了（補償OK）",
            "020": "対応完了（補償NG）",
            "021": "過去分申告",
            "022": "テスト申告",
            "023": "未調査",
            "024": "要データ抽出",
        }
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }
        return statusTable[value]
    }

    static displaySubStatus(value){
        // サブステータスに対応するステータス文字列を表示
        var statusTable = {
            "000": "未定",
            "001": "フィッシング",
            "002": "リスト攻撃",
            "003": "マルウェア",
            "004": "捨てアカ決済",
            "005": "メールアカウント乗っ取り",
            "006": "調査取下げ",
            "007": "判定不可",
            "008": "調査不可",
            "009": "第三者アクセス（不正グループ案件）",
            "010": "第三者アクセス",
            "011": "本人利用",
            "012": "一部本人利用（複数種別あり）",
        }
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }
        return statusTable[value]
    }

    static displayRegistedType(value){
        // 入力種別に対応する文字列を表示
        var statusTable = {
            "0": "ユーザー入力",
            "1": "フロント代理入力",
        }
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }
        return statusTable[value]
    }

    static displaySettlementMeans(value){
        // 支払方法に対応する文字列を表示
        var statusTable = {
            "00": "合算",
            "02": "ｄ払い残高",
            "08": "クレジット払い",
            "09": "dカード払い",
            "13": "コンビニ払い",
            "15": "代引き",
        }

        // 想定外のステータスが返却された場合
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }
        return statusTable[value]
    }

    static displayBillingMethod(value){
        // 課金種別に対応する文字列を表示
        var statusTable = {
            "01": "都度決済",
            "02": "継続課金",
            "03": "随時決済",
        }

        // 想定外のステータスが返却された場合
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }

        return statusTable[value]
    }

    static displayServiceId(value){
        // サービス種別に対応する文字列を表示
        var statusTable = {
            "01": "ドコモ払い",
            "02": "spモード決済",
            "03": "d払い（ネット）",
            "04": "d払い（バーコード）",
            "05": "その他サービス",
            "06": "d払い（iD）",
        }

        // 想定外のステータスが返却された場合
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }

        return statusTable[value]
    }

    static displaySettlementState(value){
        // 決済状態に対応する文字列を表示
        var statusTable = {
            "01": "確認中",
            "02": "処理中",
            "03": "完了",
            "04": "キャンセル済",
            "05": "増額",
            "06": "減額",
            "07": "処理中（入金済）",
            "08": "完了（入金済）",
            "09": "キャンセル済（入金済）",
            "10": "キャンセル済/返金手続済",
        }

        // 想定外のステータスが返却された場合
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }

        return statusTable[value]
    }

    static displayMailStatus(value){
        // メール承認ステータスに対応する文字列を表示
        var statusTable = {
            "001": "メール承認待ち",
            "002": "メール承認済",
            "003": "メール送信完了",
            "004": "メール送信失敗",
            "005": "メール送信リトライ中",
        }

        return statusTable[value]
    }

    static displayTradingClass(value){
        // 取引区分に対応する文字列を表示
        var statusTable = {
            "010": "ペイジー入金",
            "011": "口座間送金入金",
            "012": "口座間送金キャンセル入金",
            "013": "口座間送金拒否入金",
            "014": "送金組戻入金",
            "016": "振込不能入金",
            "017": "海外送金組戻入金",
            "020": "ペイジー入金二重収納",
            "021": "入金取消後ペイジー入金",
            "023": "コンビニ入金",
            "024": "ケータイ払い決済取消入金",
            "025": "ケータイ払い決済期限切れ入金",
            "026": "ケータイ払い決済返金入金",
            "027": "返金先口座入金",
            "028": "ｄジョブ報酬額＿入金（無料）",
            "029": "ｄジョブ報酬額＿入金（有料）",
            "031": "プリペイド決済オーソリ返品入金",
            "032": "プリペイド決済障害返品入金",
            "033": "プリペイド決済減額入金",
            "034": "プリペイド決済返品入金",
            "036": "プリペイド決済補正入金（利用金額返金）",
            "037": "プリペイド決済補正入金（発行手数料返金）",
            "038": "プリペイド決済補正入金（通信障害返金）",
            "039": "プリペイド決済補正入金（その他）",
            "03A": "プリペイド自動入金",
            "050": "モバチェ充当出金",
            "051": "銀行口座振込出金",
            "052": "口座間送金出金",
            "053": "送金組戻出金",
            "061": "コンビニ入金取消出金",
            "062": "ケータイ払い出金",
            "063": "ケータイ払い決済増額出金",
            "064": "返金元口座出金",
            "065": "銀行口座振込出金（振込無料）",
            "067": "もどきGrp異動解約＿出金",
            "070": "海外送金出金",
            "072": "プリペイド決済カード発行出金",
            "073": "プリペイド決済オーソリ出金",
            "074": "プリペイド決済増額出金",
            "075": "プリペイド決済障害取消出金",
            "076": "プリペイド決済補正出金（残高不足）",
            "077": "プリペイド決済補正出金（その他）",
            "0A0": "返金出金（回線無料）",
            "0A1": "返金出金（回線有料）",
            "0A2": "返金出金（CF無料）",
            "0A3": "返金出金（CF有料）",
            "0A4": "不能金額入金（回線）",
            "0A5": "不能金額入金（CF）",
            "0A6": "不能手数料入金（回線）",
            "0A7": "不能手数料入金（CF）",
            "0B0": "報酬額＿出金",
            "0B1": "報酬額＿入金",
            "0B2": "システム利用料＿出金",
            "0B3": "システム利用料＿入金",
            "0B4": "ポイント報酬額＿出金",
            "0B5": "ポイント報酬額＿入金",
            "0B6": "クライアント口座＿出金",
            "0B7": "クライアント口座＿入金",
            "0B8": "払い出し＿出金",
            "0B9": "払い出し＿入金",
            "0BA": "払い出し不能＿出金",
            "0BB": "払い出し不能＿入金",
            "0BC": "銀行連携＿出金",
            "0BD": "銀行連携＿入金",
            "0BE": "支払用口座＿出金",
            "0BF": "支払用口座＿入金",
            "0BG": "クライアント返金＿出金",
            "0BH": "クライアント返金＿入金",
            "0BI": "クライアント繰越＿出金",
            "0BJ": "クライアント繰越＿入金",
            "0BK": "入金用口座＿出金",
            "0BL": "入金用口座＿入金",
            "0BM": "クライアント拒否＿出金",
            "0BN": "クライアント拒否＿入金",
            "0C0": "報酬予定額＿入金",
            "0C2": "報酬予定額＿出金",
            "0C3": "収入化＿出金",
            "0C4": "報酬額＿入金（補正）",
            "0C5": "報酬額＿出金（補正）",
            "0C6": "ポイント化＿出金",
            "0C7": "報酬額＿出金（雑収）",
            "0C8": "解約返金＿入金（補正）",
            "02A": "ｄカーＳ使用料入金（無料）",
            "02B": "ｄカーＳ使用料入金（有料）",
            "02C": "障害取消入金",
            "0W0": "口座間送金出金_D",
            "0W1": "口座間送金入金_W",
            "0W2": "ペイジー入金_W",
            "0W3": "ペイジー入金二重収納_W",
            "0W4": "入金取消後ペイジー入金_W",
            "0W6": "コンビニ入金_W",
            "0W7": "ケータイ払い出金_W",
            "0W8": "決済取消入金_W",
            "0W9": "決済期限切れ入金_W",
            "0WA": "決済返金入金_W",
            "0WB": "決済増額出金_W",
            "0WC": "銀行連携＿出金_D",
            "0WD": "銀行連携＿入金_W",
            "0WE": "ATM預入＿出金（法人）_D",
            "0WF": "ATM預入＿入金（個人）_W",
            "0WG": "異動解約出金（雑収）_W",
            "0WH": "昇格ウォレット出金_W",
            "0WJ": "昇格ｄ払い残高入金_D",
            "0WK": "失効出金（雑収）_W",
            "0WL": "口座引落し＿入金_D",
            "0WM": "口座引落し＿入金_W",
            "0WN": "CF異動解約＿出金_D",
            "0WP": "送金組戻入金_W",
            "0WQ": "送金組戻出金_W",
            "0WR": "口座間送金出金（無料）_D",
            "0WS": "口座間送金入金（無料）_W",
            "0WT": "障害取消入金_W",
            "100": "手数料課金なし",
            "110": "送り手負担送金利用料",
            "111": "受け手負担送金利用料",
            "113": "海外送金手数料",
            "130": "銀行振込出金手数料",
            "131": "振込不能手数料",
            "150": "組戻出金手数料",
            "151": "組戻入金手数料",
            "156": "海外組戻手数料",
            "1C0": "dジョブ入金手数料",
            "1C1": "dジョブ出金手数料",
            "0D0": "銀行ATM預入＿出金（法人）",
            "0D1": "銀行ATM預入＿入金（個人）",
            "0D2": "銀行ATM払出＿出金（個人）",
            "0D3": "銀行ATM払出＿入金（法人）",
            "0D4": "銀行ATM払出取消＿出金（法人）",
            "0D5": "銀行ATM払出取消＿入金（個人）",
            "133": "銀行ATM払出手数料",
            "1W0": "送り手負担送金利用料_D",
            "1W1": "受け手負担送金利用料_W",
            "1W4": "組戻入金手数料_W",
            "1W5": "組戻出金手数料_W",
            "0E0": "投資預入＿出金（法人）",
            "0E1": "投資預入＿入金（個人）",
            "0E2": "投資払出＿出金（個人）",
            "0E3": "投資払出＿入金（法人）",
            "0E4": "融資預入＿出金（法人）",
            "0E5": "融資預入＿入金（個人）",
            "0E6": "融資払出＿出金（個人）",
            "0E7": "融資払出＿入金（法人）",
            "0E8": "投資預入＿出金（法人）_D",
            "0E9": "投資預入＿入金（個人）_W",
            "0EA": "融資預入＿出金（法人）_D",
            "0EB": "融資預入＿入金（個人）_W",
            "0F0": "口座間送金出金（URL）",
            "0F1": "口座間送金入金（URL）",
            "0F2": "口座間送金出金_D（URL）",
            "0F3": "口座間送金入金_W（URL）",
            "0F4": "口座間送キャン入金（URL）",
            "0F5": "口座間送金拒否入金（URL）",
            "0G0": "口座引落し＿入金_C",
            "0G1": "銀行ATM預入＿入金（個人）_C",
            "0G2": "コンビニ入金_C",
            "0GA": "ケータイ払い出金_C",
            "0GB": "決済取消入金_C",
            "0GC": "決済期限切れ入金_C",
            "0GD": "決済返金入金_C",
            "0GE": "決済増額出金_C",
            "0GF": "障害取消入金_C",
            "0GZ": "補正入金_C",
            "0GY": "補正出金_C",
            "1GZ": "補正入金手数料_C",
            "1GY": "補正出金手数料_C",
            "0GP": "異動解約＿出金_C",
            "059": "銀行口座限度額超え出金",
            "0D6": "銀行ATM限度額超え出金",
            "0D7": "銀行ATM限度額超え入金",
            "1G2": "コンビニ入金手数料_C",
            "120": "ペイジー入金手数料",
            "121": "コンビニ入金手数料",
            "1W2": "ペイジー入金手数料_W",
            "1W3": "コンビニ入金手数料_W",
            "078": "海外送金＿出金（法人）",
            "079": "海外送金＿出金（法人）_D",
            "07A": "海外送金＿出金（個人）",
            "03B": "海外送金＿入金（個人）",
            "03C": "海外送金＿入金（個人）_W",
            "03D": "海外送金＿入金（法人）",
            "0WU": "ｄ払い残高チャージ_D",
            "05B": "外部チャージ仮登録出金",
            "05C": "外部チャージ本登録出金",
            "01A": "外部チャージ取消入金",
            "01B": "外部チャージ拒否入金",
            "019": "外部チャージ入金",
            "01C": "加盟店ウォレット入金",
            "05D": "加盟店ウォレット出金",
            "05E": "加盟店ウォレット振込出金",
            "135": "加盟店ウォレット振込手数料",
            "0EC": "新融資預入_出金（法人）",
            "0ED": "新融資預入_入金（個人）",
            "0EE": "新融資払出_出金（個人）",
            "0EF": "新融資払出_入金（法人）",
            "0EG": "新融資預入_出金（法人）D",
            "0EH": "新融資預入_入金（個人）W",
            "07B": "給与振込＿出金（法人）",
            "07C": "給与振込＿出金（法人）_D",
            "07D": "経費精算＿出金（法人）",
            "07E": "経費精算＿出金（法人）_D",
            "03F": "給与振込＿入金（個人）",
            "03G": "給与振込＿入金（個人）_W",
            "03H": "経費精算＿入金（個人）",
            "03I": "経費精算＿入金（個人）_W",
            "0H1": "SO連携送金出金（個人）",
            "0H2": "SO連携送金出金（個人）_W",
            "0H3": "SO連携送金出金（個人）_C",
            "0H4": "SO連携送金入金（法人）",
            "0H5": "SO連携送金入金（法人）_W",
            "0H6": "SO連携送金入金（法人）_C",
            "03J": "預り金送金_入金（個人）",
            "03K": "預り金送金_入金（個人）_W",
            "07F": "預り金送金_出金（法人）",
            "07G": "預り金送金_出金（法人）_D",
            "05F": "銀行口座振込出金（手数料無料）",
            "05G": "銀行口座限度額超え出金（手数料無料）",
            "0D8": "銀行ATM払出＿出金（手数料無料）",
            "0D9": "銀行ATM限度額超え出金（手数料無料）",
            "0WV": "送金原資入金（法人）_D",
            "0WW": "オートチャージ＿入金_D",
            "0WX": "オートチャージ＿入金_W",
            "0GR": "オートチャージ＿入金_C",
            "07H": "別用途＿出金（法人）",
            "07I": "別用途＿出金（法人）_D",
            "03L": "別用途＿入金（個人）",
            "03M": "別用途＿入金（個人）_W",
            "05H": "送金原資返金出金",
            "0H7": "回線不備出金（個人）",
            "0H8": "回線不備出金（個人）_W",
            "0H9": "回線不備出金（個人）_C",
            "0G3": "口座引落しＢＰ＿入金_C",
            "0GS": "オートチャージＢＰ＿入金_C",
            "0J0": "口座引落しＢＰ＿入金_D",
            "0J1": "口座引落しＢＰ＿入金_W",
            "0J2": "オートチャージＢＰ＿入金_D",
            "0J3": "オートチャージＢＰ＿入金_W",
            "0J4": "不足額月初チャージBS_D",
            "0J5": "不足額月初チャージBS_W",
            "0GT": "不足額月初チャージBS_C",
            "0J6": "不足額加盟店チャージBS_D",
            "0J7": "不足額加盟店チャージBS_W",
            "0GU": "不足額加盟店チャージBS_C",
            "0J8": "不足額月初チャージBP_D",
            "0J9": "不足額月初チャージBP_W",
            "0GV": "不足額月初チャージBP_C",
            "0JA": "不足額加盟店チャージBP_D",
            "0JB": "不足額加盟店チャージBP_W",
            "0GW": "不足額加盟店チャージBP_C",
            "05L": "請求支払出金",
            "01E": "請求支払入金",
            "05J": "ペイロール振込出金",
            "05K": "ペイロール振込出金（手数料無料）",
            "01D": "ペイロール振込不能入金",
            "136": "ペイロール振込出金手数料",
            "0EI": "ｄ投資預入_出金（法人）",
            "0EJ": "ｄ投資預入_入金（個人）",
            "0EK": "ｄ投資払出_出金（個人）",
            "0EL": "ｄ投資払出_入金（法人）",
            "0EM": "ｄ投資預入_出金（法人）D",
            "0EN": "ｄ投資預入_入金（個人）W",
            "05M": "銀行口座振込出金（全ユーザ無料）",
            "05N": "銀行口座限度額超え出金（全ユーザ無料）",
            "0DA": "銀行ATM払出＿出金（全ユーザ無料）",
            "0DB": "銀行ATM限度額超え出金（全ユーザ無料）",
            "05P": "ペイロール振込出金（全ユーザ無料）",
            "0HA": "回線不備入金（法人）",
            "0HB": "回線不備入金（法人）_W",
            "0HC": "回線不備入金（法人）_C",
        }
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }
        return statusTable[value]
    }

    static displayOrderType(value){
        // オーダー種別に対応する文字列を表示
        var statusTable = {
            "01": "機種変更",
            "02": "付属品購入",
            "03": "移動機＋付属品",
        }
        if (typeof statusTable[value] === "undefined"){
            return "想定外データ"
        }
        return statusTable[value]
    }

    static displayServiceType(value){
        // // サービス種別に対応するサービス文字列を表示
        var statusTable = {
            "01": "d払い等決済サービス",
            "02": "d払い残高(チャージ/出金/送金)",
            "03": "オンラインショップ(端末購入/アクセサリ購入)",
            "04": "ahamo(端末購入/アクセサリ購入)",
        }
        return statusTable[value]
    }

    static displayServiceTypeOnlineAhamo(value){
        // // サービス種別に対応するサービス文字列を表示（オンライン・ahamo共通化）
        var statusTable = {
            "01": "d払い等決済サービス",
            "02": "d払い残高(チャージ/出金/送金)",
            "03": "オンラインショップ・ahamo(端末購入/アクセサリ購入)",
        }
        return statusTable[value]
    }

    static rowStyleClassFn(row) {
        // ステータスが完了の場合そのまま
        if (this.completestatus(row.status)){
            return ''
        }
        // 受付日時が日付文字列なので、取得した現在日付を文字列で比較する
        const registed_date = row.registed_date.replace(/-/g, '').replace(/\//g, '').slice(0, 8)
        // Date().getTimezoneOffset()でUTCとの差分を取得して+9Hすることで、環境に左右されず日本時間を取得する
        var today = new Date((Date.now()) + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
        var xday = new Date();
        var x = -7; //7日前
        xday.setDate(today.getDate() + x );
        const Y = xday.getFullYear()
        const M = ("00" + (xday.getMonth()+1)).slice(-2)
        const D = ("00" + xday.getDate()).slice(-2)
        var targetdate = Y + M + D;
        // 7日前以前の未完了データは色を変更する（cliticalRow）
        return registed_date < targetdate ? 'cliticalRow' : '';
    }

    // ステータス制限確認（最終ステータスチェック）
    static completestatus(currentstatus){
        // 現在ステータスが最終ステータス
        if(currentstatus == CommonConst.STATUS_COMPLETE_DOC || currentstatus == CommonConst.STATUS_COMPLETE_TEL){
            return true
        }
        return false
    }

    // 表示用コメントデータ構築
    static commentdata(recode, listType){
        var respData = {
            list_type: listType,
            response_name: recode["response_name"],
            created_date: recode["created_date"],
            status: this.displayStatus(recode["status"]),
            substatus: this.displaySubStatus(recode["substatus"]),
            comment: recode["comment"] === '' ? 'コメントなし' : recode["comment"],
        }
        return respData
    }

    // サービスの略称取得（CSVファイル名用）
    static get_serviceName(value){
        var serviceTable = {
            '01': 'dcmpay',     // d払い等決済サービス
            '02': 'wallet',     // d払い残高(旧ウォレット機能)
            '03': 'onlineshop', // オンラインショップ
            '04': 'ahamo',      // ahamo
        }
        if (typeof serviceTable[value] === "undefined"){
            return "想定外データ"
        }
        return serviceTable[value]
    }

    // 現在日時取得(YYYYMMDDHHｍｍSS形式)
    static get_datetime(){
        var dt = new Date()
        var y = dt.getFullYear()
        var m = ('00' + (dt.getMonth()+1)).slice(-2)
        var d = ('00' + dt.getDate()).slice(-2)
        var h = ('00' + dt.getHours()).slice(-2)
        var mm = ('00' + dt.getMinutes()).slice(-2)
        var s = ('00' + dt.getSeconds()).slice(-2)
        var datetime = y + m + d + h + mm + s

        return datetime
    }

    // YYYYMMDDを日付形式に変換（カレンダーに戻す）
    static convert_date(strdate){
        var tmpdate = strdate.substr(0, 4) + "-" + strdate.substr(4, 2) + "-" + strdate.substr(6, 2)

        return tmpdate
    }

    // CSV出力
    static download_csv(registed_date, tradingInfo, fileName){
        var err_msg = ''
        try {
            // Header取得
            var csv = this.get_header(tradingInfo)
            // DetailLine取得
            var rows = this.get_rows(registed_date, tradingInfo)
            csv += rows
            let blob = new Blob([csv], { type: 'text/csv' })
            let link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = fileName
            link.click()
            URL.revokeObjectURL(link.href)
        } catch(e) {
            err_msg = 'CSVファイルのダウンロードが失敗しました。'
        }
        return err_msg
    }

    // Header取得
    static get_header(tradingInfo){
        var header = '\ufeff' + '受付日時'  // EXCEL使用時の文字化け防止 UTF8BOM付
        tradingInfo.cols.forEach(col => {
            // ステータス、サブステータス、最終更新日時以外のヘッダ項目を編集
            if (col["field"] !== "settlement_status" && col["field"] !== "substatus" && col["field"] !== "updated_date"){
                header += ',' + col["label"]
            }
        })
        return header
    }

    // DetailLine取得
    static get_rows(registed_date, tradingInfo){
        var rows = ''
        tradingInfo.rows.forEach(row => {
            var line = '\r\n' + registed_date
            tradingInfo.cols.forEach(col => {
                // ステータス、サブステータス、最終更新日時以外の項目を編集
                if (col["field"] !== "settlement_status" && col["field"] !== "substatus" && col["field"] !== "updated_date"){
                    if (col["formatFn"]) {
                        line += ',' + col["formatFn"](row[col["field"]])
                    }
                    else {
                        line += ',' + row[col["field"]]
                    }
                }
            })
            rows += line
        })
        return rows
    }

    // 検索条件の取得
    static restoreQueryParams(component){
        if(component.$store.getters.queryParams){
            // 保存情報と一致した場合
            if(component.serviceType == component.$store.getters.queryParams.service_type && component.listType == component.$store.getters.queryParams.list_type){
                return component.$store.getters.queryParams
            }
        }
        return {}
    }

    // 調査取下げ件チェック
    static displayEnquiry_status(status, service_type){
        // サービス種別ごとに、問い合わせステータスに対応する文字列を表示
        if (service_type == CommonConst.SERVICE_TYPE_DCMPAY){
            // 問い合わせステータスに対応する文字列を表示
            if (status === CommonConst.STATUS_COMPLETE_OK || status === CommonConst.STATUS_COMPLETE_NG ||
                status === CommonConst.STATUS_PREVIOUS
            ){
                return "調査完了"
            }
            else if (status === CommonConst.STATUS_COMPLETE_DOC || status === CommonConst.STATUS_COMPLETE_TEL ||
                status === CommonConst.STATUS_DECLARATION || status === CommonConst.STATUS_DECLARATION_RECEIPT ||
                status === CommonConst.STATUS_CORRECTION_POINT || status === CommonConst.STATUS_CORRECTION_AMOUNT ||
                status === CommonConst.STATUS_CORRECTION_CC_CANCEL || status === CommonConst.STATUS_CORRECTION_MIXTURE ||
                status === CommonConst.STATUS_CORRECTION_PLAN
            ){
                return "後続対応中"
            }
            else if (status === CommonConst.STATUS_INVESTIGATION_WITHDRAWN){
                return "調査取下げ"
            }
            else{
                return "調査中"
            }
        }
        else{
            // 問い合わせステータスに対応する文字列を表示
            if (status === CommonConst.STATUS_COMPLETE_DOC || status === CommonConst.STATUS_COMPLETE_TEL ||
                status === CommonConst.STATUS_CORRECTION_POINT || status === CommonConst.STATUS_CORRECTION_AMOUNT ||
                status === CommonConst.STATUS_CORRECTION_CC_CANCEL || status === CommonConst.STATUS_CORRECTION_MIXTURE ||
                status === CommonConst.STATUS_COMPLETE_OK || status === CommonConst.STATUS_COMPLETE_NG ||
                status === CommonConst.STATUS_PREVIOUS || status === CommonConst.STATUS_CORRECTION_PLAN
            ){
                return "調査完了"
            }
            else if (status === CommonConst.STATUS_INVESTIGATION_WITHDRAWN){
                return "調査取下げ"
            }
            else{
                return "調査中"
            }
        }
    }

    static session_error(component){
        component.session_error_flg = true
        alert("問題が発生しました。\n最初からやり直してください。")
    }

    // フィッシングURL入力値チェック
    static check_fishing_url(url){
        var error_massage = ""
        if(url.length > 0){
            var url_lines = url.split(/\n/)
            if(url.length > 3000){
                error_massage = "フィッシングサイトURLは合計3000文字以内で入力してください。"
            }
            else{
                for(var i=0; i<url_lines.length; i++){
                    if(url_lines[i].length > 0){
                        if(url_lines[i].match("^http.*") == null){
                            error_massage = "フィッシングサイトURLはhttpで始まるURLを入力してください。"
                            break
                        }
                    }
                    else{
                        error_massage = "空行は入力できません。"
                        break
                    }
                }
            }
        }
        return error_massage
    }

    // アコーディオンマークダウンをHTMLに変換する（pageType:'preview', 'consumer', 'agency'）
    static convertAccordionTags (content) {
        if (!content || typeof content !== 'string') {
            return content;
        }
        // 軽量マークダウン形式のアコーディオンを検出: [accordion:ボタンテキスト]
        if (!content.includes('[accordion:')) {
            // アコーディオンタグがない場合は改行をHTMLに変換
            return content.replace(/\n/g, '<br>');
        }

        // [accordion:ボタンテキスト]内容[/accordion] の形式を検索
        const accordionRegex = /\[accordion:([^\]]+)\]([\s\S]*?)\[\/accordion\]/g;
        let match;
        let convertedContent = content;
        let collapseCounter = 1;

        // HTMLタグへの変換
        while ((match = accordionRegex.exec(content)) !== null) {
            const fullMatch = match[0];
            const buttonText = match[1].trim();
            const innerContent = match[2].trim();
            const collapseId = `collapse-caution-${collapseCounter}`;
            collapseCounter++;

            // シンプルなアコーディオンHTMLを生成
            const accordionHtml = this.generateAccordionHtml(buttonText, innerContent, collapseId);

            convertedContent = convertedContent.replace(fullMatch, accordionHtml);
        }

        // アコーディオンマークダウンが含まれていた場合JavaScript関数を追加
        if (convertedContent !== content) {
            if (typeof window.toggleAccordion !== 'function') {
                window.toggleAccordion =  (id) => {
                    try {
                        const content = document.getElementById('content-' + id);
                        const icon = document.getElementById('icon-' + id);
                        if (content && icon) {
                            const isHidden = content.style.display === 'none';
                            content.style.display = isHidden ? 'block' : 'none';
                            icon.textContent = isHidden ? '▼' : '▶';
                        }
                    } catch (error) {
                        console.error('アコーディオン操作エラー:', error);
                    }
                };
            }
        }

        // アコーディオン処理後の残りの改行も処理
        convertedContent = convertedContent.replace(/\n/g, '<br>');

        return convertedContent;
    }

    // アコーディオンHTML生成ヘルパー関数（シンプル版）
    static generateAccordionHtml(buttonText, innerContent, collapseId) {
        // アコーディオン内容の改行とHTMLタグを適切に処理
        let formattedContent = innerContent

        // 既にHTMLタグが含まれている場合はそのまま使用
        if (formattedContent.includes('<p>') || formattedContent.includes('<br>')) {
            // HTMLタグが含まれている場合はそのまま使用
            formattedContent = innerContent
        } else {
            // プレーンテキストの場合は改行を<br>タグに変換
            formattedContent = innerContent.replace(/\n/g, '<br>')
        }

        return [
            '<div class="simple-accordion" style="border: 1px solid #ddd; margin-bottom: 10px;">',
            '<div class="accordion-header" style="background-color: #f8f9fa; padding: 10px; cursor: pointer; user-select: none;" onclick="toggleAccordion(\'' + collapseId + '\');">',
            '<span id="icon-' + collapseId + '" style="margin-right: 8px;">▶</span>',
            buttonText,
            '</div>',
            '<div id="content-' + collapseId + '" class="accordion-content" style="display: none; padding: 15px; border-top: 1px solid #ddd;">',
            formattedContent,
            '</div>',
            '</div>'
        ].join('');
    }
}
